import React from 'react';
import PropTypes from 'prop-types';

import Stack from '../stack';
import Ghost from '../ghost';

const Skeleton = ({ children = [], isLoading = false, items = [{}], gap = 'small', direction = 'vertical', width }) => {
    if (isLoading) {
        return (
            <Stack gap={gap} direction={direction} width={width}>
                {items.map((shape, index) => (
                    <Ghost key={index} {...shape} />
                ))}
            </Stack>
        );
    }

    return <>{children}</>;
};

Skeleton.propTypes = {
    children: PropTypes.node,
    /** Peek  <a href="/#/Design system/Stack">`Stack`</a> component to see underlying props. */
    direction: PropTypes.oneOf(['vertical', 'horizontal']),
    /** Peek  <a href="/#/Design system/Stack">`Stack`</a> component to see underlying props. */
    gap: PropTypes.oneOf(['none', 'xxs', 'xs', 'small', 'median', 'base', 'medium', 'regular', 'large', 'xl', 'xxl']),
    isLoading: PropTypes.bool,
    /** Peek  <a href="/#/Design system/Ghost">`Ghost`</a> component to see underlying props. */
    items: PropTypes.arrayOf(
        PropTypes.shape({
            width: PropTypes.number,
            height: PropTypes.string,
        }),
    ),
    width: PropTypes.number,
};

export default Skeleton;
